<div class="tooltip" [ngClass]="['tooltip--'+position]" [class.tooltip--visible]="visible" [style.left]="left + 'px'"
  [style.top]="top + 'px'">
  {{tooltip}}
</div>
